<mainpanel
  *ngIf="loader$ | async as loader"
  [pageData]="pageData"
  [Title]="title$ | async"
  [hideSearchBox]="true"
  [hideSearchDropdown]="false"
  (onSubmit)="onFilterSearch(loader)"
>
  <div filters>
    <div container>
      <div class="d-flex flex-column mb-5">
        <h6 class="mb-2">From - To</h6>
        <datepicker
          [isFloatingLabel]="false"
          placeholder="From"
          appearance="outline"
          [(date)]="loader.From"
        >
        </datepicker>
      </div>

      <div class="d-flex flex-column mb-5">
        <datepicker
          [isFloatingLabel]="false"
          placeholder="To"
          appearance="outline"
          [(date)]="loader.To"
        ></datepicker>
      </div>
    </div>
  </div>

  <div content *ngIf="data$ | async as data">
    <div class="container-fluid mt-5">
      <app-pie-chart
        [config]="data.pieChartConfig"
        [data]="data.pieChartData"
      ></app-pie-chart>
    </div>
  </div>
</mainpanel>
